import PropTypes from 'prop-types'
import React from 'react'
import aboutPic from '../../images/about.png'

const about = ({ article, articleTimeout, redirectClick, close }) => (
  <article
    id="about"
    className={`
      	${article === 'about' ? 'active' : ''}
      	${articleTimeout ? 'timeout' : ''} 
      `}
    style={{ display: 'none' }}
  >
    <h2 className="major">About</h2>
    <span className="image main">
      <img src={aboutPic} alt="" />
    </span>
    <p>
      Hi! I'm <strong>Leonil Omayan</strong> a self thought web developer, age of 29 years old currently live in Purok 18 Mintal, Davao City, Philippines, and Bachelor Degree Holder of Information Technology at St. John Paul II College of Davao.
    </p>
    <p>From the basic programming that i learned at my School, I start learning web development by reading documentations, watching video tutorials and attending web development seminars.
    </p>
    <p>
      Because of passion that's why i pursue to learn more deeper about web development. I also love exploring new techniques and on how my code much cleaner and much readable that's why i came up creating some awesome <a href="#" onClick={() => { redirectClick('project'); }}> projects. </a>

    </p>
    <p>To know me more you can get my <a href="https://1drv.ms/b/s!AkOoM47Iau-ogoFFFXeZwuUkmVjJKA?e=QmAVG9">resume</a> .</p>
    <div className="pagination">
      <div className="pagination-left">

      </div>
      <div className="pagination-right">
        <button
          onClick={() => {
            redirectClick('skills');
          }}
        >
          Skills <span className="icon fas fa-arrow-right"></span>
        </button>
      </div>
    </div>

    {close}
  </article>
);

about.propTypes = {
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  redirectClick: PropTypes.func,
  close: PropTypes.object
}


export default about